module.exports = __webpack_public_path__ + "img/symbol_16_free.5832d1f5.png";